import React from 'react'

const convertNewlineToBreak = (text: string) => {
  const lines = text.split('\n')
  return lines.map((line, index, array) => {
    return index === array.length - 1 ? (
      line
    ) : (
      <>
        {line}
        <br />
      </>
    )
  })
}

const TextWithLineBreaks = ({ text }: { text: string }) => (
  <>{convertNewlineToBreak(text)}</>
)

export default TextWithLineBreaks
